export default "__VITE_ASSET__DlQIiYwD__"